import classnames from "classnames";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";
import {Link} from "react-router";

import {DATE_FORMAT_ISO} from "config/constants";
import CalendarLink from "v2/components/responsive/CalendarLink";

const DateFilter = (props, context) => {
  const {location: {query}, params: {date}} = context;
  const {className} = props;

  const today = moment();
  const current = moment(date);

  const nextWeek = current.clone().add(1, "weeks");
  const prevWeek = current.clone().subtract(1, "weeks");
  const tomorrow = current.clone().add(1, "days");
  const yesterday = current.clone().subtract(1, "days");

  return (
    <div className={classnames("btn-toolbar", className)}>
      <div className="btn-group btn-group-sm">
        <Link
          activeClassName="active"
          className="btn btn-default"
          to={{
            pathname: `/${today.format(DATE_FORMAT_ISO)}`,
            query,
          }}>
          Today
        </Link>
      </div>

      <div aria-label="Dates" className="btn-group btn-group-sm" role="group">
        <Link
          className="btn btn-default hidden-xs"
          title="To Previous Week"
          to={{
            pathname: `/${prevWeek.format(DATE_FORMAT_ISO)}`,
            query,
          }}>
          &laquo;
        </Link>
        <Link
          className="btn btn-default"
          title="Day Before"
          to={{
            pathname: `/${yesterday.format(DATE_FORMAT_ISO)}`,
            query,
          }}>
          &lsaquo;
        </Link>
        <Link
          className="btn btn-default"
          title="Day After"
          to={{
            pathname: `/${tomorrow.format(DATE_FORMAT_ISO)}`,
            query,
          }}>
          &rsaquo;
        </Link>
        <Link
          className="btn btn-default hidden-xs"
          title="To Next Week"
          to={{
            pathname: `/${nextWeek.format(DATE_FORMAT_ISO)}`,
            query,
          }}>
          &raquo;
        </Link>
      </div>

      <CalendarLink
        className="btn-group btn-group-sm CalendarLink NoOutlineOnFocus" />
    </div>
  );
};

DateFilter.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
};
DateFilter.propTypes = {
  className: PropTypes.string,
};

export default DateFilter;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DateFilter.js
 **/